import {gql} from 'apollo-angular';
import {baseResponseGraphqlField} from '../../../../base.graphql';


export const CITIZEN_VERIFY_OPT_PASSWORD = gql`
mutation CitizenVerifyOtpPassword($passwordOtp: String!) {
    citizenVerifyOtpPassword(passwordOtp: $passwordOtp) {
    ${baseResponseGraphqlField}
  }
}
`;
